import { cn } from "@lib/cn"
import { AlertTriangle } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "./Button"

export function PageError({
  title,
  message,
  onRetry,
  // Defaults to "Reintentar". Override when the button does something the
  // word "retry" describes badly — a stale-bundle recovery reloads the
  // document, and promising a retry there reads as a lie when the page
  // visibly navigates.
  retryLabel,
  className,
}: {
  title?: string
  message?: string
  onRetry?: () => void
  retryLabel?: string
  className?: string
}) {
  const { t } = useTranslation("common")
  return (
    <div
      className={cn("flex flex-col items-center justify-center gap-2 py-16 text-center", className)}
      role="alert"
    >
      <AlertTriangle className="text-danger h-10 w-10" aria-hidden />
      <h2 className="text-ink text-base font-semibold">{title ?? t("state.error.title")}</h2>
      <p className="text-ink-muted max-w-sm text-sm">{message ?? t("state.error.message")}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry} className="mt-2">
          {retryLabel ?? t("actions.retry")}
        </Button>
      )}
    </div>
  )
}
